/**
 * An appointment's place as screens show it (0233): a place set on the
 * form or the card reads as its name and its address; a row with only the
 * note's text (or an older row) reads as that text, its Location.
 */
import type { AppointmentRow } from '@/lib/clientRecord';
import { formatPlace } from '@/lib/address';

export interface AppointmentPlaceLines {
  /** The place's name, for a set place. */
  name: string | null;
  /** The place's address on one line, for a set place with a street. */
  address: string | null;
  /** The location text, for a row with no set place. */
  text: string | null;
}

export function appointmentPlaceLines(r: AppointmentRow): AppointmentPlaceLines {
  if (r.locationName !== undefined || r.locationParts !== undefined) {
    const address = r.locationParts === undefined ? '' : formatPlace(null, r.locationParts);
    return { name: r.locationName ?? null, address: address === '' ? null : address, text: null };
  }
  return { name: null, address: null, text: r.location ?? null };
}

/** What the edit form opens on (0233): a set place's name, parts and the
 *  Directory entry it came from; for a row with only text, the text as the
 *  address on file, which the form shows as "On file as" over empty boxes. */
export function appointmentPlaceValues(r: AppointmentRow): Record<string, unknown> {
  if (r.locationName !== undefined || r.locationParts !== undefined) {
    return {
      ...(r.locationName !== undefined ? { location_name: r.locationName } : {}),
      location_address: r.locationParts ?? null,
      ...(r.locationDirectoryOrgId !== undefined ? { location_directory_org_id: r.locationDirectoryOrgId } : {}),
      ...(r.locationDirectoryIndividualId !== undefined ? { location_directory_individual_id: r.locationDirectoryIndividualId } : {}),
    };
  }
  return r.location !== undefined ? { location_address: r.location } : {};
}
